<script setup>
import { DateTime } from 'luxon';

const props = defineProps({
  date: {
    type: Array,
    default: () => [],
  },

  theme: {
    type: String,
    default: 'purple',
    validator(value) {
      return ['purple', 'gray', 'black'].includes(value);
    },
  },

  size: {
    type: String,
    default: 'm',
    validator(value) {
      return ['m', 's'].includes(value);
    },
  },
  iconSize: {
    type: String,
    default: 'm',
    validator(value) {
      return ['m', 's'].includes(value);
    },
  },

  withPaddings: {
    type: Boolean,
    default: true,
  },
});
const emit = defineEmits(['click']);

function checkIsToday(date) {
  return date.toString() === DateTime.local().startOf('day').toString();
}

const { t, locale } = useI18n();

const formattedDate = computed(() => {
  return props.date
    .map((date) => {
      if (!date) return t('form.selectDate');

      const dateObject = DateTime.fromISO(date);
      const currentYear = DateTime.now().year;

      const isToday = checkIsToday(dateObject);

      if (props.date.length === 2) {
        return dateObject.toFormat(
          dateObject.year !== currentYear ? 'dd.MM.yy' : 'dd.MM',
          { locale: locale.value },
        );
      } else if (isToday) {
        return t('form.today');
      } else {
        return dateObject.toFormat('EEE, d MMM', { locale: locale.value });
      }
    })
    .join('-');
});
</script>

<template>
  <button
    type="button"
    class="ui-date-display"
    :class="[
      `ui-date-display--theme--${theme} ui-date-display--size--${size}`,
      { 'ui-date-display--with-paddings': withPaddings },
    ]"
    @click="emit('click')"
  >
    <CIcon
      class="ui-date-display__icon"
      :class="`ui-date-display__icon--size--${iconSize}`"
      name="calendar"
    />

    <ClientOnly>
      <span class="ui-date-display__font">
        {{ formattedDate }}
      </span>
      <template #fallback>
        <span class="ui-date-display__font">
          {{ t('form.selectDate') }}
        </span>
      </template>
    </ClientOnly>
  </button>
</template>
